import React, { Fragment, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import Search from "../../components/InputFields/Search";
import workflow_header from "../../assets/images/workflow-header.png";
import "./Workflow.css";
import FormList from "./Forms/FormList";
import AddForm from "./Forms/AddForm";
import AddApplicationType from "./ApplicationType/AddApplicationType";
import ApplicationTypeList from "./ApplicationType/ApplicationTypeList";
import DocumentTypeList from "./DocumentType/DocumentTypeList";
import AddDocumentType from "./DocumentType/AddDocumentType";
import AddWorkflow from "./CreateWorkflow/AddWorkflow";
import WorkflowList from "./CreateWorkflow/WorkflowList";
import { useLocation } from "react-router";

const Workflow = ({ direction, ...args }) => {
  // const navigate = useNavigate();
  const [openAddOrg, setOpenAddOrg] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const [CurrentTab, setCurrentTab] = useState(location.state?.tab || "formList");

  const renderView = () => {
    switch (CurrentTab) {
      case "formList":
        return <FormList searchValue={searchValue}/>;
      case "addForm":
        return <AddForm setCurrentTab={setCurrentTab}/>;
      case "applicationTypeList":
        return <ApplicationTypeList searchValue={searchValue}/>;
      case "addApplicationType":
        return <AddApplicationType setCurrentTab={setCurrentTab}/>;
      case "documentTypeList":
        return <DocumentTypeList  searchValue={searchValue}/>;
      case "addDocumentType":
        return <AddDocumentType searchValue={searchValue} setCurrentTab={setCurrentTab}/>;
        case "workflowList":
          return <WorkflowList  searchValue={searchValue}/>;
        case "addWorkflow":
          return <AddWorkflow setCurrentTab={setCurrentTab}/>;
      default:
        return null; // Or a default component if necessary
    }
  };

  return (
    <Fragment>
      <div className="workflow_blocks working-blocks_container">
        <div className="d-flex justify-content-between align-items-center main-header-block header-bg flex-wrap gap-2">
          <div className="left_header d-flex align-items-center gap-2">
            <img src={workflow_header} />
            <h2 className="home-title">Workflow</h2>
          </div>
          <div className="right_header_block d-flex justify-content-between align-items-center flex-wrap">
            <div className="right_header d-flex align-items-center">
              {(CurrentTab == "formList" ||  CurrentTab == "documentTypeList" || CurrentTab == "applicationTypeList" || CurrentTab == "workflowList")  && <Search value={searchValue} onChange={(e) => {setSearchValue(e.target.value.toLowerCase());}}/>}
              <Dropdown
                isOpen={openAddOrg}
                toggle={() => setOpenAddOrg((prev)=> !prev)}
                direction={direction}
              >
                <DropdownToggle caret size="lg" className="column_blk p-0 pe-3 m-0">
                  <div className="for_details header-add-icon">
                    <i className="fa fa-plus"></i>
                  </div>
                </DropdownToggle>
                <DropdownMenu {...args}>
                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => setCurrentTab("addApplicationType")}>
                    <div
                      className="add_hosp"
                    >
                      Create Application Type
                    </div>
                  </DropdownItem>
                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => setCurrentTab("addForm")}>
                    <div
                      className="add_hosp"
                    >
                      {" "}
                      Upload PDF Form
                    </div>
                  </DropdownItem>
                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => setCurrentTab("addDocumentType")}>
                    <div
                      className="add_hosp"
                    >
                      Create Required Document
                    </div>
                  </DropdownItem>
                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => setCurrentTab("addWorkflow")}>
                    <div
                      className="add_hosp"
                    >
                      Create Workflow
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4 tab_content_blk">
          <div className="tabs_button">
            <button className="cancel_btn_blk d-flex justify-content-between align-items-center" onClick={() => setCurrentTab("formList")} style={(CurrentTab === "addForm" || CurrentTab === "formList") ? { color: "white", backgroundColor: "#335FFC", fontWeight:"700" } : null}>Forms</button>
            <button className="cancel_btn_blk d-flex justify-content-between align-items-center" onClick={() => setCurrentTab("applicationTypeList")} style={(CurrentTab === "applicationTypeList" || CurrentTab === "addApplicationType") ? { color: "white", backgroundColor: "#335FFC" } : null}>Application Types</button>
            <button className="cancel_btn_blk d-flex justify-content-between align-items-center"  onClick={() => setCurrentTab("documentTypeList")} style={(CurrentTab === "documentTypeList" || CurrentTab === "addDocumentType") ? { color: "white", backgroundColor: "#335FFC" } : null}>Required Document</button>
            <button className="cancel_btn_blk d-flex justify-content-between align-items-center" onClick={() => setCurrentTab("workflowList")}  style={(CurrentTab === "workflowList" || CurrentTab === "addWorkflow") ? { color: "white", backgroundColor: "#335FFC" } : null}>Workflows</button>
          </div>
            <div className="Form_workflow_container table_listing_color">
                {renderView()}
              </div>
            </div>
      </div>
    </Fragment>
  );
};

export default Workflow;
